import { render, staticRenderFns } from "./DepList.vue?vue&type=template&id=5ce4c989&scoped=true"
import script from "./DepList.vue?vue&type=script&lang=js"
export * from "./DepList.vue?vue&type=script&lang=js"
import style0 from "./DepList.vue?vue&type=style&index=0&id=5ce4c989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4c989",
  null
  
)

export default component.exports